import { render, staticRenderFns } from "./Corporate.vue?vue&type=template&id=1469b0d8&scoped=true&"
import script from "./Corporate.vue?vue&type=script&lang=ts&"
export * from "./Corporate.vue?vue&type=script&lang=ts&"
import style0 from "./Corporate.vue?vue&type=style&index=0&id=1469b0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1469b0d8",
  null
  
)

export default component.exports